import { IRefComment } from 'constants/interfaces'

import { IComment } from 'constants/interfaces'
import keys from 'constants/keys'

export const getObjectType = (type: number) => {
  switch (type) {
    case keys.POST_TYPE.GROUP_POST:
      return keys.COMMENT_OBJECT_TYPE.MESSAGE_ON_GROUP
    case keys.POST_TYPE.GROUP_POST_ANNOUNCEMENT:
      return keys.COMMENT_OBJECT_TYPE.MESSAGE_ON_ANNOUNCEMENT_GROUP
    default:
      return keys.COMMENT_OBJECT_TYPE.REF_COMMENT
  }
}

export const extractRefComment = (comment?: IComment): IRefComment | null => {
  if (!comment) return null

  const { oid, message, created_by, files, images, videos, audios } = comment
  return { oid, message, created_by, files, images, videos, audios }
}
